import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { SxStyle } from '../../types';

const styles: SxStyle = {
  closeButton: (theme) => ({
    position: 'absolute',
    right: '8px',
    top: '8px',
    color: theme.palette.grey[500],
  }),
};

export interface BaseDialogProps extends DialogProps {
  title?: string;
  stepper?: JSX.Element;
  onClose?: () => void;
}

export default function BaseDialog({
  title,
  stepper,
  open,
  onClose,
  children,
  ...props
}: BaseDialogProps) {
  return (
    <Dialog open={open} maxWidth={'sm'} fullWidth {...props}>
      {title && (
        <DialogTitle sx={(theme) => ({ borderBottom: `1px solid ${theme.palette.grey[300]}` })}>
          {title}
          {onClose ? (
            <IconButton aria-label="close" onClick={onClose} sx={styles.closeButton}>
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
      )}
      {stepper}
      {children}
    </Dialog>
  );
}
